module.exports = __webpack_public_path__ + "static/media/startup.f89e07ee.svg";